import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Base } from "./base";
import { getLayerShape, getMaskValue } from "../utils";
export var BaseMapTileLayerManager = /*#__PURE__*/function (_Base) {
  _inherits(BaseMapTileLayerManager, _Base);

  var _super = _createSuper(BaseMapTileLayerManager);

  // only support vector layer
  function BaseMapTileLayerManager(parent, mapService, rendererService) {
    var _this;

    _classCallCheck(this, BaseMapTileLayerManager);

    _this = _super.call(this);
    _this.parent = parent;
    _this.children = parent.layerChildren;
    _this.mapService = mapService;
    _this.rendererService = rendererService;

    _this.setSubLayerInitOption();

    _this.initTileFactory();

    return _this;
  }

  _createClass(BaseMapTileLayerManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      this.children.filter(function (layer) {
        return layer.inited;
      }).filter(function (layer) {
        return layer.isVisible();
      }).map(function (layer) {
        layer.hooks.beforeRenderData.call();
        layer.hooks.beforeRender.call();

        if (layer.masks.length > 0) {
          // 清除上一次的模版缓存
          _this2.rendererService.clear({
            stencil: 0,
            depth: 1,
            framebuffer: null
          });

          layer.masks.map(function (m) {
            m.hooks.beforeRenderData.call();
            m.hooks.beforeRender.call();
            m.render();
            m.hooks.afterRender.call();
          });
        }

        layer.render();
        layer.hooks.afterRender.call();
      });
    }
  }, {
    key: "setSubLayerInitOption",
    value: function setSubLayerInitOption() {
      var _colorAttribute$scale, _sizeAttribute$scale;

      var _ref = this.parent.getLayerConfig(),
          _ref$zIndex = _ref.zIndex,
          zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex,
          _ref$opacity = _ref.opacity,
          opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
          _ref$mask = _ref.mask,
          mask = _ref$mask === void 0 ? false : _ref$mask,
          _ref$stroke = _ref.stroke,
          stroke = _ref$stroke === void 0 ? '#fff' : _ref$stroke,
          _ref$strokeWidth = _ref.strokeWidth,
          strokeWidth = _ref$strokeWidth === void 0 ? 0 : _ref$strokeWidth,
          _ref$strokeOpacity = _ref.strokeOpacity,
          strokeOpacity = _ref$strokeOpacity === void 0 ? 1 : _ref$strokeOpacity,
          _ref$workerEnabled = _ref.workerEnabled,
          workerEnabled = _ref$workerEnabled === void 0 ? false : _ref$workerEnabled,
          sourceLayer = _ref.sourceLayer;

      var source = this.parent.getSource();
      var parentParserType = source.getParserType();
      var colorAttribute = this.parent.getAttribute('color');
      var basemapColor = (colorAttribute === null || colorAttribute === void 0 ? void 0 : (_colorAttribute$scale = colorAttribute.scale) === null || _colorAttribute$scale === void 0 ? void 0 : _colorAttribute$scale.field) || '#fff';
      var sizeAttribute = this.parent.getAttribute('size');
      var basemapSize = (sizeAttribute === null || sizeAttribute === void 0 ? void 0 : (_sizeAttribute$scale = sizeAttribute.scale) === null || _sizeAttribute$scale === void 0 ? void 0 : _sizeAttribute$scale.field) || 1;
      var layerShape = getLayerShape(this.parent.type, this.parent);
      this.initOptions = {
        usage: 'basemap',
        layerType: this.parent.type,
        shape: layerShape,
        zIndex: zIndex,
        opacity: opacity,
        sourceLayer: this.getSourceLayer(parentParserType, sourceLayer),
        basemapColor: basemapColor,
        basemapSize: basemapSize,
        mask: getMaskValue(this.parent.type, mask),
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: strokeOpacity,
        // worker
        workerEnabled: workerEnabled
      };
    }
  }]);

  return BaseMapTileLayerManager;
}(Base);